import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './reducers';

export const selectAuthState = createFeatureSelector<fromAuth.State>(fromAuth.featureKey);

export const selectAuth = createSelector(selectAuthState, state => state.user);
